module.exports = __webpack_public_path__ + "static/facebook-e60db1574cfcfd54138efeae592f2c0b.mp4";